<div *ngIf="amountInShipment">
  <b>{{ amountInShipment }}</b> in shipments
</div>
<div *ngIf="!amountInShipment"></div>
<div
  [matTooltip]="'Different FBA type already selected, please deselect first'"
  [matTooltipDisabled]="disableTooltip"
>
<input  [ngClass]="{'alert-input': params.data.SelectedQty > params.data.LocalMinusReserved && !onlyShipyardUser && isShipmentQueue,'queued_sku' : isQueued}"
    type="number"
    ignoreWheelDirective
    tabindex="2"
    min="0"
    [matTooltip]="params.data.SelectedQty > params.data.LocalMinusReserved && !onlyShipyardUser ? 'Insufficient local stock': null"
    (keypress)="onlyNumberKey($event)"
    (click)="inputClicked($event)"
    [formControl]="amount"
    (focusout)="valueChange($event)"
    [myautofocus]="
      params.node.rowIndex === shipyardService.cellFocusedIndex
    "
  />
  <img *ngIf="isQueued" class="img-fluid ms-2" src="./../../../assets/images/checkmark-circle.svg" alt="">  
  <img *ngIf="loading" class="load_dimenstions" src="assets/images/loading.gif" alt="">
</div>
<div
  class="suggested-count"
  *ngIf="(params.props && user.isShipyard!== 1) || (user.isShipyard== 1 && user.isPlanYard && params.props)"
  [ngClass]="{
    'suggested-count--neutral': suggestedAmount === 0 || !suggestedAmount,
    'suggested-count--added': suggestedAmount === amount.value,
    'suggested-count--negetive': suggestedAmount < 0
  }"
  (click)="addAmountToShipment($event, suggestedAmount)"
>
  Suggested: {{ (suggestedAmount || 0) | number}}
  <span
        *ngIf="roundedAmount && suggestedAmount > 0"
        class="suggested-count--alert"
        [matTooltip]= "suggestedTooltip" 
        matTooltipClass="error-tooltip"
      >
      <i class="fal fa-boxes "></i>
      </span>
</div>